import { BaseChartDirective } from 'ng2-charts';
import { ShortcutMenu } from './../../model/GlobalMenu';
import { Agent } from 'src/app/model/Agent';
import { DataTableRow } from './../controls/datatable/datatable.component';
import { UserInfo } from './../../model/User';
import { EventService } from './../../service/event.service';
import { DiscoveredProduct, ProductExt } from './../../model/Product';
import { SoftwareInventoryService } from './../../service/software-inventory.service';
import { AgentService } from './../../service/agent.service';
import { SolutionInfo } from './../../model/SolutionInfo';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { tap, switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ChartConfiguration,  ChartType } from 'chart.js';
import { LoginState } from 'src/app/model/LoginState';
import { Utils } from 'src/app/utils';
import { ColumnType, DataTableColumn } from '../controls/datatable/datatable.component';
import { UnregisteredAgentPipe } from 'src/app/pipe/unregistered-agent.pipe';
import { Router } from '@angular/router';
import { Modal } from '../controls/modal/modal.service';import { NotificationUI } from 'src/app/model/NotificationUI';
;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {
  userAuthInfo: UserInfo;
  today: number = Date.now();
  solutionInfo: SolutionInfo = new SolutionInfo();
  allAgents: Agent[] = [];
  unregisteredAgents: Agent[] = [];
  discoveredProductGroup: DiscoveredProduct[];
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  agentChartData: ChartConfiguration['data'] = {
    datasets: [
      { data: [], 
        label: '',
        backgroundColor: ["rgba(9,188,239,0.8)", "rgba(229,92,80,0.8)", "rgba(157,228,249,0.8)", "rgba(245,208,112,0.8)"],
        borderColor: ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        hoverBorderColor: ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        hoverBackgroundColor: ["rgba(9,188,239,1)", "rgba(229,92,80,1)", "rgba(157,228,249,1)", "rgba(245,208,112,1)"],
      }
    ],
    labels: [$localize`Online`, $localize`Offline`, $localize`Unregistered`, $localize`Disabled`]
  };
  agentChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        text: $localize`Systems by status`,
        display: true,
        font: {
          family: 'OpenText Sans',
          size: 24,
          weight: 'normal'
        },
        color: '#FFFFFF'
      },
      legend: {
        display: true,
        position: 'right',
        labels: {
          font: {
            family: 'OpenText Sans',
            size: 14,
            
          },
          color: '#FFFFFF'
        }
      },
      tooltip: {
        
      }
    }
  };
  agentChartType: ChartType = 'doughnut';
  isAgentChartDataLoaded: boolean = false;
  showAvailableEnvironments: boolean = false;

  //subscription
  solutionInfoSubscription: Subscription;
  loginEventSubscription: Subscription;

  //notification
  notificationTitle: string = $localize`Notifications`;
  notificationId: string = 'otsc-home-notification';
  notifications: NotificationUI[] = [];
  isNotificationsLoading: boolean = true;
  notificationLink: string = '/activities/notifications';
  notificationLinkDesc: string = $localize`Open notifications`;

  //patches and updates
  patchesAndUpdatesTitle: string = $localize`Patches and Updates`;
  patchesAndUpdatesId: string = 'otsc-home-patches-and-updates';
  patchesAndUpdatesTableId: string = 'otsc-home-patches-and-updates-table';
  patchesAndUpdatesCols: DataTableColumn[] = [new DataTableColumn("product", "Product", ColumnType.LINK, false, "80"),
  new DataTableColumn("status", "Status", ColumnType.STATUS, false, "20")];
  patchesAndUpdatesRows: DataTableRow[] = [];
  isPatchesAndUpdatesLoading: boolean = true;
  patchesAndUpdatesLink: string = '/products';
  patchesAndUpdatesLinkDesc: string = $localize`Open products`;

  //pending systems
  pendingSystemsTitle: string = $localize`Pending systems`;
  pendingSystemsId: string = 'otsc-home-pending-systems';
  pendingSystemsTableId: string = 'otsc-home-pending-systems-table';
  pendingSystemsCols: DataTableColumn[] = [new DataTableColumn("systemName", "Name", ColumnType.LINK, false, "50"),
  new DataTableColumn("osName", "OS", ColumnType.STRING, false, "30"),
  new DataTableColumn("status", "Status", ColumnType.STATUS, false, "20")];
  pendingSystemsRows: DataTableRow[] = [];
  isPendingSystemsLoading: boolean = true;
  pendingSystemsLink: string = '/systems/overview';
  pendingSystemsLinkDesc: string = $localize`Open systems`;

  //shortcuts
  shortcuts: ShortcutMenu[] = [];

  constructor(private authService: AuthenticationService,
    private agentService: AgentService,
    private siService: SoftwareInventoryService,
    private eventService: EventService,
    private unregisteredAgentPipe: UnregisteredAgentPipe,
    private router: Router,
    private modal: Modal) {
    this.solutionInfoSubscription = this.eventService.currentSolutionInfo$.subscribe(newSolutionInfo => {
      this.solutionInfo = newSolutionInfo;
      this.notifications = Utils.processNotifications(this.solutionInfo.notificationDetails.notifications);
      this.agentService.getStats().pipe(
        tap(resp => {
          if (resp.body.total > 0 || resp.body.unregistered > 0) {
            this.agentChartData.datasets[0].data = [resp.body.online, resp.body.offline, resp.body.unregistered, resp.body.disabled];
          } else {
            this.agentChartData.datasets[0].data = [];
          }
          this.isAgentChartDataLoaded = true;
          this.chart?.update();
        }),
        switchMap(() => this.agentService.listNotApproved().pipe(
          tap(resp => {
            this.unregisteredAgents = resp.body;
            this.pendingSystemsRows = [];
            this.unregisteredAgents.forEach((agent) => {
              agent.status = agent.isOnline ? 'otsc-icon-status-available' : 'otsc-icon-status-closed';
              agent.attrTitle = agent.isOnline ? $localize`Online` : $localize`Offline`;
              this.pendingSystemsRows.push(new DataTableRow(agent, null));

            });
            this.isPendingSystemsLoading = false;
          })
        ))
      ).subscribe();
      this.isNotificationsLoading = false;
    });
    this.loginEventSubscription = this.eventService.loginState$.subscribe(newLoginState => {
      if (newLoginState === LoginState.SignedIn) {
        this.userAuthInfo = this.authService.getLoggedInUser();
        this.init();
      }
    });
  }


  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.userAuthInfo = this.authService.getLoggedInUser();
      this.init();
    } else {
      this.router.navigate(['home']);
    }
  }

  ngOnDestroy() {
    this.solutionInfoSubscription.unsubscribe();
    this.loginEventSubscription.unsubscribe();
  }

  init(): void {
    this.shortcuts = Utils.getHomepageShortcuts(this.userAuthInfo);
    this.patchesAndUpdatesRows = [];
    this.isPatchesAndUpdatesLoading = true;
    this.isPendingSystemsLoading = true;
    this.siService.getDiscoveredProducts(this.userAuthInfo.settings.environmentId).pipe(
      tap(resp => {
        this.discoveredProductGroup = resp.body;
        this.discoveredProductGroup.forEach((discoveredProduct) => {
          let productGroup = [];
          let status = 'otsc-icon-status-outdated';

          discoveredProduct.products.forEach((product) => {
            productGroup.push(product.name + " " + product.version);
            if(product.availablePatches){
              if(product.availablePatches.length == 0){
                status = 'otsc-icon-status-available';
              } else {
                for (let i = 0; i < product.availablePatches.length; i++) {
                  if (!product.availablePatches[i].isSupportHotfix || (i > 1 && product.availablePatches[i].isSupportHotfix)) {
                    status = 'otsc-icon-status-available';
                    break;
                  }

                  if (product.availablePatches[i].availableHotfixCount > 0) {
                    status = 'otsc-icon-status-available';
                    break;
                  }
                }
              }
            }
          });

          let prod = { product: productGroup.join(", "), status: status, attrTitle: status === 'otsc-icon-status-available' ? $localize`No updates available` : $localize`One or more updates are available to download` }
          this.patchesAndUpdatesRows.push(new DataTableRow(prod, null));
        });

        this.isPatchesAndUpdatesLoading = false;
      })
    ).subscribe();
  }

  handleNotificationLink(notification: NotificationUI): void {
    Utils.handleNotificationLink(notification, this.router, this.modal);
  }

  patchesAndUpdatesRowClicked(product: ProductExt): void {
    this.router.navigate(['products']);
  }

  pendingSystemsRowClicked(agentRow: DataTableRow): void {
    this.router.navigate(['/systems/details/' + agentRow.data.agentID]);
  }
}
